import moment from 'moment/moment'

import { AosSeverity } from '../../common/types/AosSeverity'
import { TaskCategory } from './TaskCategory'
import { TaskProcessType } from './TaskProcessType'

export type WeeklyBoardTasksFilters = {
    category: TaskCategory[]
    processType: TaskProcessType[]
    severity: AosSeverity[]
    assigneeId: string[]
    text?: string
    weekEnd: string
}

export const initialWeeklyBoardTasksFilters: WeeklyBoardTasksFilters = {
    category: [],
    processType: [],
    severity: [],
    assigneeId: [],
    text: '',
    weekEnd: moment().day(7).toISOString(),
}
